import React from "react";
import { projects } from "../data";
import ProjectCard from "./ProjectCard";
import { HiOutlineCode } from "react-icons/hi";
import SectionHeader from "./SectionHeader";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

function Projects() {
  const { elementRef, isVisible } = useRevealOnScroll();
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section
      id="projects"
      ref={elementRef}
      className={`bg-main-bg-dark/40 px-6 py-20 md:px-16 lg:px-28 ${
        isVisible ? "animate-fade-in-up" : ""
      }`}
    >
      <div className="mx-auto max-w-6xl">
        <SectionHeader
          icon={<HiOutlineCode />}
          eyebrow={t.projects.eyebrow}
          title={t.projects.title}
        />
        <div className="project-card-container mt-12 grid grid-cols-1 gap-10 md:grid-cols-2 xl:grid-cols-3">
          {projects.map((project, index) => (
            <div
              key={project.id}
              className={`transform transition duration-500 ${
                isVisible ? "animate-fade-in-up" : ""
              } hover:-translate-y-2 hover:scale-[1.02]`}
              style={{ animationDelay: `${index * 120}ms` }}
            >
              <ProjectCard project={project} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
